import Api from "@/services/api";

const basic = "container";
export default {
  getOne(id) {
    return Api.default().get("/" + basic + "/" + id);
  },
  post(id, params) {
    let formData = new FormData();
    if (params.file) {
      formData.append("file", params.file);
    }
    if (params.field) {
      formData.append("field", params.field);
    }
    if (params.table) {
      formData.append("table", params.table);
    }
    return Api.default().post("/" + basic + "/" + id, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
